import { render, staticRenderFns } from "./PopupProduct.vue?vue&type=template&id=56ab2714&scoped=true&"
import script from "./PopupProduct.vue?vue&type=script&lang=js&"
export * from "./PopupProduct.vue?vue&type=script&lang=js&"
import style0 from "./PopupProduct.vue?vue&type=style&index=0&id=56ab2714&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ab2714",
  null
  
)

export default component.exports